import React, { useState } from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ content, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      <div
        className="relative inline-block"
        onClick={() => setShowTooltip(!showTooltip)}
      >
        {children}
      </div>
      {showTooltip && (
        <div className="border-solid border-[1px] border-gray-300 mt-4 p-4 rounded z-10 bg-white">
          <div className="font-normal">{content}</div>
        </div>
      )}
    </>
  );
};

export default Tooltip;